<template>
	<div>
		<avue-form v-model="formPeriod" :option="optionPeriod" @submit="submitPeriod">
			<template slot="today" slot-scope="scope">
				<span>{{ scope.value }}</span>
			</template>
			<template slot="effectiveDate">
				<el-date-picker
					v-model="formPeriod.effectiveDate"
					:disabled="isSubmitted"
					:picker-options="pickerOptions"
					format="yyyy-MM-dd"
					placeholder="请选择 生效日期"
					type="date"
					value-format="yyyy-MM-dd"
					@change="effectiveDateChanged"></el-date-picker>
			</template>
			<template slot="period" slot-scope="scope">
				<span>{{ scope.value }}天</span>
			</template>
			<template slot="defeasanceDate" slot-scope="scope">
				<span>{{ scope.value }}</span>
			</template>
			<template slot="shortRate" slot-scope="scope">
				<span>{{ scope.value }}%</span>
			</template>
			<template slot="endorsePremium" slot-scope="scope">
				<span>{{ scope.value }}元</span>
			</template>
			<template slot="menuForm">
				<el-button v-if="isSubmitted" icon="el-icon-edit" @click="modifyPeriod">修改</el-button>
			</template>
		</avue-form>
		<span class="red-bold"></span>

		<endorse-time-hint-dialog
			ref="timeHintDialog"
			:last-time-data="lastTimeData"
			@onEndorseTimeSure="onShowInsureData"></endorse-time-hint-dialog>
	</div>
</template>

<script>
import {checkEffectiveDate} from '@/api/insurance/policy'
import {insureMap} from '@/const/crud/insurance/product'
import {toYYYYmmdd} from '@/util/date'
import EndorseTimeHintDialog from '@/components/insurance/endorseTimeHintDialog'

export default {
	name: 'PeriodEndorseForm',
	components: {EndorseTimeHintDialog},
	props: {
		minEffectiveDate: {
			type: Date | Number,
		},
		maxEffectiveDate: {
			type: Date | Number,
		},
		basePrice: {
			type: Number | String,
		},
		shortRatesList: {
			type: Array,
		},
		insureType: String | Number,
	},
	data() {
		return {
			lastTimeData: [],
			doneData: {},
			optionPeriod: {
				submitBtn: true,
				submitText: '确认',
				emptyBtn: false,
				menuBtn: true,
				labelWidth: 160,

				column: [
					{
						label: '当前日期',
						prop: 'today',
						span: 24,
						slot: true,
					},
					{
						label: '生效日期',
						prop: 'effectiveDate',
						span: 14,
						placeholder: ' ',
						slot: true,
						rules: [
							{
								required: true,
								message: '请选择 生效日期',
								trigger: 'blur',
							},
						],
					},
					{
						label: '保障期限',
						prop: 'period',
						span: 10,
						placeholder: ' ',
						slot: true,
					},
					{
						label: '保险止期',
						prop: 'defeasanceDate',
						span: 24,
						slot: true,
					},
				],
				group: [
					{
						display: false,
						arrow: false,
						column: [
							{
								label: '保费比例',
								prop: 'shortRate',
								span: 14,
								slot: true,
							},
							{
								label: '新增人员保费',
								prop: 'endorsePremium',
								span: 10,
								slot: true,
							},
						],
					},
				],
			},
			formPeriod: {
				today: '',
				effectiveDate: '',
				period: '',
				defeasanceDate: '',
				effectiveBeginDate: '',
				term: 0,
			},
			isSubmitted: false,
			pickerOptions: {
				disabledDate: (time) => {
					let result = true

					if (!this.validatenull(this.minEffectiveDate)) {
						if (!this.validatenull(this.maxEffectiveDate)) {
							result = time.getTime() > this.maxEffectiveDate || time.getTime() < this.minEffectiveDate
						} else {
							result = time.getTime() < this.minEffectiveDate
						}
					}

					return result
				},
			},
		}
	},
	created() {
		this.init()
	},
	methods: {
		init() {
			this.formPeriod.today = this.getDateString(new Date())
		},
		submitPeriod(form, done) {
			let {effectiveDate, today} = form
			let {effectiveBeginDate = ''} = this.formPeriod
			let tempData = Date.parse(today)
			let effectiveBeginMill = Date.parse(effectiveBeginDate)
			if (effectiveBeginMill > tempData) {
				tempData = effectiveBeginMill
			}
			//计算时间
			let tempNum = this.daysBetween(tempData, Date.parse(effectiveDate))
			let minNum = insureMap.get(this.insureType).plan.insureAddMinDate
			this.lastTimeData = [effectiveDate, toYYYYmmdd(Date.parse(effectiveDate) - 24 * 60 * 60 * 1000)]
			this.doneData = done
			if (tempNum > minNum + 1) {
				//显示弹窗
				this.$refs.timeHintDialog.onShowDialog()
			} else {
				//判断批增日期
				this.onShowInsureData()
			}
		},
		//弹出提示
		onShowInsureData() {
			let tempMonth = this.getDateMill(new Date(this.formPeriod.effectiveDate))
			if (tempMonth) {
				this.$confirm(`你当前的保费会按照【${tempMonth}个月】收取，请仔细确认是否继续批增？`, '提示', {
					confirmButtonText: '确认投保',
					cancelButtonText: '重新选择日期',
				})
					.then(() => {
						//确认
						this.onCheckEffectDate()
					})
					.catch(() => {
						if (this.doneData) {
							this.doneData()
						}
					})
			} else {
				this.onCheckEffectDate()
			}
		},

		//请求数据
		onCheckEffectDate() {
			let dateInfo = {
				effectiveDate: this.lastTimeData[0],
			}
			//  查询保单起始日期是否有效
			checkEffectiveDate(Object.assign(dateInfo))
				.then((response) => {
					this.$message({
						message: '确认 成功',
						type: 'success',
					})
					this.optionPeriod.column.forEach((item, index) => {
						if (item.prop == 'effectiveDate') {
							item.disabled = true
						}
					})
					this.optionPeriod.submitBtn = false
					this.isSubmitted = true
					this.$emit('onSubmitted', this.getSubmitData())
				})
				.catch(() => {})
				.finally(() => {
					if (this.doneData) {
						this.doneData()
					}
				})
		},
		modifyPeriod() {
			this.optionPeriod.submitBtn = true
			this.isSubmitted = false
			this.$emit('onUnsubmitted')
		},
		effectiveDateChanged(val) {
			this.calcEndorsePeriod()
			this.$emit('periodChange')

			if (!this.validatenull(this.basePrice) && !this.validatenull(this.shortRatesList)) {
				this.optionPeriod.group[0].display = true
			}
		},
		getData() {
			return this.formPeriod
		},
		getSubmitData() {
			return {
				effectiveDate: !this.validatenull(this.formPeriod.effectiveDate) ? this.formPeriod.effectiveDate : '',
				expiryDate: this.formPeriod.defeasanceDate || '',
				term: this.formPeriod.period || '',
			}
		},
		setData(data) {
			Object.assign(this.formPeriod, data)
			this.calcEndorsePeriod()
		},
		calcEndorsePeriod() {
			let beginDate = this.formPeriod.effectiveDate
			let endDate = this.formPeriod.defeasanceDate
			if (!this.validatenull(beginDate)) {
				this.formPeriod.period = this.daysBetween(Date.parse(beginDate), Date.parse(endDate))

				if (!this.validatenull(this.shortRatesList) && !this.validatenull(this.basePrice)) {
					let months = this.monthsBetween(beginDate, new Date(endDate))
					let shortRate = this.shortRatesList[months]
					this.formPeriod.shortRate = shortRate
					this.formPeriod.endorsePremium = parseFloat((this.basePrice * shortRate) / 10000)
				}
			}
		},
		getDateString(date) {
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			if (month < 10) {
				month = '0' + month
			}
			let day = date.getDate()
			if (day < 10) {
				day = '0' + day
			}
			return year + '-' + month + '-' + day
		},
		daysBetween(from, to) {
			let days = (to - from) / 24 / 3600 / 1000
			return parseInt(days) + 1
		},
		monthsBetween(from, to) {
			let months = to.getMonth() - from.getMonth() + 12 * (to.getFullYear() - from.getFullYear())

			if (to.getDate() < from.getDate()) {
				months--
			}

			return parseInt(months) + 1
		},
		//获取当前日期与保单起始日期毫秒值, 参数为选择的日期
		getDateMill(date) {
			//计算选择的日期和生效日期差几个月
			let choiceMonth = date.getMonth()
			//effectiveBeginDate 生效时间
			let tempEffectiveData = new Date(this.formPeriod.effectiveBeginDate)
			let effectiveMonth = tempEffectiveData.getMonth()
			let tempMonth = choiceMonth >= effectiveMonth ? choiceMonth - effectiveMonth : choiceMonth + 12 - effectiveMonth
			console.log('选择的日期和生效日期差:---', tempMonth)

			let oneDay = 24 * 60 * 60 * 1000
			//同一个月的，当前日期是否在 大于失效日期 - 3天
			if (tempMonth === 0) {
				//defeasanceDate 失效日期
				return (new Date(this.formPeriod.defeasanceDate).getTime() - Date.now()) / oneDay <= 4 ? 1 : 0
			}
			//非同一个月
			//保单生效日期+相差的月份
			let year = tempEffectiveData.getFullYear()
			let month = tempEffectiveData.getMonth()
			let day = tempEffectiveData.getDate()
			year = year + parseInt((month + tempMonth) / 12)
			month = (month + tempMonth) % 12
			let maxDayCount = new Date(year, month + 1, 0).getDate()
			if (day > maxDayCount) {
				day = maxDayCount
			}
			let tempMill = new Date(`${year}-${month + 1}-${day - 1} 23:59:59`).getTime()
			console.log(`${year}-${month + 1}-${day - 1}`, this.formPeriod.effectiveDate, tempMill - date.getTime())
			//获取到相差几个月的时间 - 选择的时间，是否在4天内
			return date.getTime() >= tempMill - 4 * oneDay && date.getTime() <= tempMill
				? this.formPeriod.term - tempMonth + 1
				: 0
		},
	},
}
</script>

<style lang="scss" scoped></style>
